const SortIconTypes = {
  sortable: 'sortable',
  down: 'down',
  up: 'up'
}

export default SortIconTypes
